import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * AdminRoute — protects the admin console.
 * Mirrors EmployeeRoute, but requires a valid ADMIN session. Without this guard,
 * typing /dashboard (or any admin path) rendered the console shell to anyone,
 * with no login. The API already 401s, so no data leaked — but the UI must not
 * open. A missing/non-admin session is bounced to the admin login.
 */
export default function AdminRoute({ children }) {
  const token = localStorage.getItem('crm_token') || localStorage.getItem('token');
  let role = null;
  try { role = JSON.parse(localStorage.getItem('crm_user') || 'null')?.role; } catch { role = null; }

  if (token && role === 'admin') return children;

  // Not an admin session. A logged-in employee goes to their own home; everyone
  // else to the employee login — the main door for this app, since most users
  // are reps. (Admins reach their console after signing in at /login.)
  const employeeSession = localStorage.getItem('employee_token') && localStorage.getItem('employee_id');
  return <Navigate to={employeeSession ? '/employee/home' : '/employee/login'} replace />;
}
